export default {"src":"/_next/static/media/feature-circle2.574d6aee.svg","height":190,"width":198};